module.exports = __webpack_public_path__ + "img/whitedelete.f2a59cc5.svg";